import { ENGINE_VERSION, analyzeGlobalStability, computeQuantities, type QuantitiesResult, type GlobalStabilityAnalysis, type Project, type ReportSettings, type WallInput, type WallResult } from "@tasduvar/engine";
import { runAnalysis } from "../../state/useAnalysis";
import type { ProviderSettings } from "../../provider/types";
import { fileDigest } from "./hash";

export { fileDigest };

export interface ReportWall {
  wall: WallInput; result: WallResult | null; error: string | null;
  /** Toptan göçme (bölüm açık ve duvarda etkinse; senkron hesaplanır — worker gerekmez) */
  globalStability?: GlobalStabilityAnalysis | null; globalStabilityError?: string;
  /** Metraj (bölüm açıkken; saf, sonuçtan türetilir) */
  quantities?: QuantitiesResult;
}
export interface ReportModel {
  project: Project; settings: ReportSettings; walls: ReportWall[];
  digest: string; engineVersion: string; generatedAt: string;
  branding: ProviderSettings["branding"];
}

export function buildReportModel(project: Project, settings: ReportSettings, branding: ProviderSettings["branding"]): ReportModel {
  const selected = settings.wallIds === "all" ? project.walls : project.walls.filter((w) => (settings.wallIds as string[]).includes(w.id));
  const walls: ReportWall[] = selected.map((wall) => {
    const a = runAnalysis(wall);
    const rw: ReportWall = { wall, result: a.result, error: a.error };
    if (settings.sections.globalStability && a.result && wall.globalStability?.enabled) {
      try { rw.globalStability = analyzeGlobalStability(wall); }
      catch (e) { rw.globalStability = null; rw.globalStabilityError = e instanceof Error ? e.message : "Toptan göçme hesabı yapılamadı"; }
    }
    if (settings.sections.quantities && a.result) rw.quantities = computeQuantities(wall, a.result);
    return rw;
  });
  return { project, settings, walls, digest: fileDigest(project), engineVersion: ENGINE_VERSION, generatedAt: new Date().toISOString(), branding };
}
